import api from './api';
class AuthService {
  // Authentication methods
  async signIn(email: string, senha: string) {
    const response = await api.post('/api/auth/signin', { email, senha });
    const { token, guid, name, roles, subscription, error, role } = response.data;
    
    if (error) {
      throw new Error(error);
    }
    
    if (!token) {
      throw new Error('Token não encontrado na resposta');
    }
    
    localStorage.setItem('@ThinkWay:token', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    return { 
      user: { guid, name, email, role, roles },
      subscription: subscription || null
    };
  }
  
  async signUp(nome: string, email: string, senha: string) {
    return await api.post('/api/auth/signup', { nome, email, senha });
  }
  
  async renewToken() {
    const response = await api.post('/api/auth/renew-token');
    
    // Update token if a new one was provided
    if (response.data.token) {
      localStorage.setItem('@ThinkWay:token', response.data.token);
      api.defaults.headers.common['Authorization'] = `${response.data.token}`;
    }
    
    return response.data;
  }
  
  signOut() {
    localStorage.removeItem('@ThinkWay:token');
    api.defaults.headers.common['Authorization'] = '';
  }
  
  // User management methods
  async updateUserName(newName: string) {
    const response = await api.put(`/api/users/name`, { newName });
    return response.data;
  }
  
  async updateUserPassword(currentPassword: string, newPassword: string) {
    const response = await api.put(`/api/users/password`, {
      currentPassword,
      newPassword
    });
    return response.data;
  }
  
  // Token management
  getStoredToken() {
    return localStorage.getItem('@ThinkWay:token');
  }
  
  setAuthHeader(token: string) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
}

export default new AuthService();
